import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { HyperlinkRestrictedBaseModal } from '../../../../../../components/HyperlinkRestrictedBaseModal';

import styles from './abstracted_content.module.scss';

type Props = {
  content: string;
  url: string;
  source: string;
  onClick?: () => void;
};

export const AbstractedContent: FC<Props> = ({
  content,
  url,
  source,
  onClick,
}) => {
  const { body: { textContent = null } = {} } =
    new DOMParser().parseFromString(content, 'text/html') || {};
  if ((textContent?.length ?? 0) > 500) {
    const abstractedContent = textContent?.substring(0, 500);
    return (
      <>
        {abstractedContent} ...{' '}
        <HyperlinkRestrictedBaseModal
          className={styles.readMore}
          url={url}
          source={source}
        >
          <span onClick={onClick}>
            <FormattedMessage id="components/AbstractedContent.tsx/1" />
          </span>
        </HyperlinkRestrictedBaseModal>
      </>
    );
  }
  return <span>{textContent}</span>;
};
